import { render, staticRenderFns } from "./modalAddBusinessEvent.vue?vue&type=template&id=3280a0e0&scoped=true&"
import script from "./modalAddBusinessEvent.vue?vue&type=script&lang=js&"
export * from "./modalAddBusinessEvent.vue?vue&type=script&lang=js&"
import style0 from "./modalAddBusinessEvent.vue?vue&type=style&index=0&id=3280a0e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3280a0e0",
  null
  
)

export default component.exports